module.exports = __webpack_public_path__ + "assets/img/7cb5af127722ee4477be3509813636af.png";